module.exports = __webpack_public_path__ + "img/background.0b565f22.jpg";